import { CompRef, DocumentServicesObject } from '@wix/document-services-types';
import { EventType } from '@wix/editor-platform-sdk-types';
import { componentSelectionChangedHandler } from './componentSelectionChanged';
import { HostEventData } from './types';
import { appRefreshCompleted } from './appRefreshCompleted';

export type EventData = {
  eventType: string;
  eventPayload?: object;
};

const getHostEventData = <T extends object>(
  event: string,
): HostEventData<T> => {
  const emptyData: EventData = {
    eventType: '',
    eventPayload: {},
  };

  try {
    const data = JSON.parse(event) as { args?: EventData };

    const { eventType, eventPayload = {} } = data?.args ?? emptyData;

    return { eventType, ...eventPayload } as HostEventData<T>;
  } catch {
    return {
      eventType: '',
    } as HostEventData<T>;
  }
};

export const subscribeOnHostEvents = (
  documentServicesAPI: DocumentServicesObject,
) => {
  /**
   * In studio/responsive selection after app refresh works correctly,
   * so we do this trick for other editors or if host is not defined for some reason
   */
  // const host = window.commonConfig?.host;
  // const isEditorClassic = host === 'EDITOR' || !host;
  let shouldSkipSelectionChangedEvent = false;

  documentServicesAPI.platform.subscribeOnCustomAppEvents((e) => {
    const hostEvent = getHostEventData<{ componentRefs: CompRef[] }>(e);
    const eventType = hostEvent.eventType;

    switch (eventType) {
      case EventType.componentSelectionChanged:
        if (!hostEvent.componentRefs?.length) {
          break;
        }

        if (shouldSkipSelectionChangedEvent) {
          shouldSkipSelectionChangedEvent = false;

          return;
        }

        componentSelectionChangedHandler(documentServicesAPI, hostEvent);

        break;

      case EventType.appRefreshCompleted:
        appRefreshCompleted(documentServicesAPI);

        // if (isEditorClassic) {
        shouldSkipSelectionChangedEvent = true;
        // }

        break;
    }
  });
};
